import { useChartData, useOrgData, useSubscriptionData } from "../../hooks";
import { DataUploadCard } from "../cards/DataUploadCard";
import { OrganizationSetupCard } from "../cards/OrganizationSetupCard";
import { SecurityActivityCard } from "../cards/SecurityActivityCard";
import { TrialPlanCard } from "../cards/TrialPlanCard";
import { UserAdoptionCard } from "../cards/UserAdoptionCard";
import { UtilitySetupCard } from "../cards/UtilitySetupCard";

export function DashboardCards() {
  const { data, isLoading, error } = useOrgData();
  const {
    data: subscriptionData,
    isLoading: subscriptionLoading,
    error: subscriptionError,
  } = useSubscriptionData();

  const {
    data: chartData,
    isLoading: chartLoading,
    error: chartError,
  } = useChartData();

  const orgProgress = data?.result?.tenantProgressPercentage ?? 0;
  const tasks = data?.result?.tasks ?? [];
  console.log("tasks", tasks);
  const utilityProgrss = data?.result?.overallUtilityProgress ?? 0;

  const subscriptionDetails = subscriptionData?.result ?? [];

  if (isLoading || subscriptionLoading || chartLoading) {
    return <div>Loading...</div>;
  }

  if (error || subscriptionError || chartError) {
    return <div>Error loading data.</div>;
  }

  // Pass the API data safely or fallback empty objects
  const activeUserDetails = chartData?.result?.activeUserDetails ?? {};
  const todaysActiveUsers = chartData?.result?.todaysActiveUsers ?? 0;
  const weekGrowthInPercentage = chartData?.result?.weekGrowthInPercentage ?? 0;

  const userLoginDetails = chartData?.result?.loginDetails ?? {};
  const totalAuthorizedCount = chartData?.result?.totalAuthorizedCount ?? 0;
  const totalUnauthorizedCount = chartData?.result?.totalUnauthorizedCount ?? 0;

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <OrganizationSetupCard progress={orgProgress} tasks={tasks} />
        <UtilitySetupCard orgSetupData={data?.result} progress={utilityProgrss} />
        <DataUploadCard />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <UserAdoptionCard
          activeUserDetails={activeUserDetails}
          todaysActiveUsers={todaysActiveUsers}
          weekGrowthInPercentage={weekGrowthInPercentage}
        />
        <SecurityActivityCard
          userLoginDetails={userLoginDetails}
          totalAuthorizedCount={totalAuthorizedCount}
          totalUnauthorizedCount={totalUnauthorizedCount}
        />
        <TrialPlanCard subscriptionDetails={subscriptionDetails} />
      </div>
    </div>
  );
}
